/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * По этому URL можно узнать suggested_values по одной букве. Не может быть одновременно с suggested_values.
 */
export interface SearchAttributeSuggestedQueryUrl { 
    href: string;
    method: string;
}